export const BILLING_TYPES = {
    BILLABLE: 'Billable',
    NON_BILLABLE: 'NonBillable',
    BOTH: null  // Special case: BOTH maps to null for database
};

export const getBillingName = (billing) => {
    switch (billing) {
        case BILLING_TYPES.BILLABLE:
            return 'Billable';
        case BILLING_TYPES.NON_BILLABLE:
            return 'Non-Billable';
        case BILLING_TYPES.BOTH:
        case null:  // Handle both BILLING_TYPES.BOTH (null) and actual null values
            return 'Both';
        default:
            return '';
    }
};

export const getBillingBackgroundColor = (billing) => {
    switch (billing) {
        case BILLING_TYPES.BILLABLE:
            return '#E6F4EA';
        case BILLING_TYPES.NON_BILLABLE:
            return '#FEF3E2';
        case BILLING_TYPES.BOTH:
        case null:  // Handle both BILLING_TYPES.BOTH (null) and actual null values
            return '#D1FAE5';
        default:
            return '#F3F4F6';
    }
};

export const getBillingTextColor = (billing) => {
    switch (billing) {
        case BILLING_TYPES.BILLABLE:
            return '#1E8E3E';
        case BILLING_TYPES.NON_BILLABLE:
            return '#D97706';
        case BILLING_TYPES.BOTH:
        case null:  // Handle both BILLING_TYPES.BOTH (null) and actual null values
            return '#065F46';
        default:
            return '#6B7280';
    }
};